export default "__VITE_ASSET__DUuF7Jx6__"